module.exports = __webpack_public_path__ + "static/chunks/src/page-ottawa/part-benefits/assets/image-warranty.406280b3329438047345638df10707a4.webp";